enum OsTypes {
  Windows = 'windows',
  Linux = 'linux',
  Android = 'android',
  IOS = 'ios',
}

export const getOsIcon = (lastVisitOs: string | null | undefined) => {
  switch (lastVisitOs) {
    case OsTypes.Windows:
      return 'fa-brands fa-windows';
    case OsTypes.Linux:
      return 'fa-brands fa-linux';
    case OsTypes.Android:
      return 'fa-brands fa-android';
    case OsTypes.IOS:
      return 'fa-brands fa-apple';
    default:
      return 'fa-solid fa-laptop';
  }
};
